module.exports = __webpack_public_path__ + "media/images/report_areas/jaimiesig-15c6df34db853440c128825eed620d61.png";